/**
 * Confidence thresholds for field extraction
 */
export enum EConfidenceThreshold {
  HIGH = 80,
  MEDIUM = 50,
  LOW = 30,
}

/**
 * Confidence level enum
 */
export enum EConfidenceLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

/**
 * Gets the confidence level based on score
 *
 * @param confidence - Confidence score (0-100)
 * @returns Confidence level (low, medium, or high)
 */
export function getConfidenceLevel(confidence: number): EConfidenceLevel {
  if (confidence >= EConfidenceThreshold.HIGH) {
    return EConfidenceLevel.HIGH;
  }
  if (confidence >= EConfidenceThreshold.MEDIUM) {
    return EConfidenceLevel.MEDIUM;
  }
  return EConfidenceLevel.LOW;
}

/**
 * Gets the number of active bars based on confidence level
 *
 * @param confidenceLevel - Confidence level
 * @returns Number of active bars (1-3)
 */
export function getActiveBars(confidenceLevel: EConfidenceLevel): number {
  if (confidenceLevel === EConfidenceLevel.HIGH) return 3;
  if (confidenceLevel === EConfidenceLevel.MEDIUM) return 2;
  return 1;
}
